import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogContent,
  TextField,
  Button,
  Snackbar,
  CircularProgress,
  Grid,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
} from "@mui/material";
import {
  AddCircleOutline as AddCircleOutlineIcon,
  AddCircle,
} from "@mui/icons-material";
import useData from "../hooks/useData";
import ModalDialogTitle from "../../../common/ModalDialogTitle";
import {
  getFirestore,
  collection,
  query,
  where,
  orderBy,
  getDocs,
} from "firebase/firestore";

const AddForm = ({ onSuccess }) => {
  const [open, setOpen] = useState(false);
  const [school_name, setName] = useState("");
  const [city, setCity] = useState("");
  const [address, setAddress] = useState("");
  const [state, setState] = useState("");
  const [zip, setZip] = useState("");
  const [county, setCounty] = useState("");
  const [district, setDistrict] = useState("");
  const [main_contact, setMainContact] = useState("");
  const [main_phone, setMainPhone] = useState("");
  const [main_email, setMainEmail] = useState("");
  const [second_contact, setSecondContact] = useState("");
  const [second_email, setSecondEmail] = useState("");
  const [pathway, setPathway] = useState("");
  const [operations, setOperations] = useState("");
  const [loading, setLoading] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [pathwayOptions, setPathwayOptions] = useState([]);
  const [operationsOptions, setOperationsOptions] = useState([]);
  const { postData } = useData();

  useEffect(() => {
    const fetchDropdownOptions = async () => {
      const db = getFirestore();
      const pathwayQuery = query(
        collection(db, "users"),
        where("ccpAdminFlag", "==", true),
        orderBy("name")
      );
      const operationsQuery = query(
        collection(db, "users"),
        where("ccpAdminFlag", "==", true),
        orderBy("name")
      );
      try {
        const pathwaySnapshot = await getDocs(pathwayQuery);
        const operationsSnapshot = await getDocs(operationsQuery);

        setPathwayOptions(pathwaySnapshot.docs.map((doc) => doc.data().name));
        setOperationsOptions(
          operationsSnapshot.docs.map((doc) => doc.data().name)
        );
      } catch (error) {
        console.error("Error fetching dropdown options:", error);
      }
    };

    fetchDropdownOptions();
  }, []);

  const handleFormSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);
    try {
      const newData = {
        school_name,
        address,
        city,
        state,
        zip,
        county,
        district,
        main_contact,
        main_phone,
        main_email,
        second_contact,
        second_email,
        pathway,
        operations,
      };
      await postData(newData);
      setSnackbarOpen(true);
      setOpen(false);
      onSuccess(); // Trigger list refresh in parent component
    } catch (error) {
      console.error("Error adding item:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  return (
    <>
      <Button
        variant="contained"
        color="success"
        startIcon={<AddCircleOutlineIcon />}
        onClick={() => setOpen(true)}
        sx={{ color: "white" }}
      >
        Add School
      </Button>
      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        maxWidth="lg"
        fullWidth
      >
        <ModalDialogTitle onClose={() => setOpen(false)}>
          Add School
        </ModalDialogTitle>
        <DialogContent>
          {loading ? (
            <CircularProgress />
          ) : (
            <form onSubmit={handleFormSubmit}>
              <Grid container spacing={2}>
                <Grid item xs={12} md={4}>
                  <TextField
                    label="School Name"
                    value={school_name}
                    onChange={(e) => setName(e.target.value)}
                    fullWidth
                    required
                    margin="normal"
                  />
                </Grid>
                <Grid item xs={12} md={4}>
                  <TextField
                    label="Address"
                    value={address}
                    onChange={(e) => setAddress(e.target.value)}
                    fullWidth
                    margin="normal"
                  />
                </Grid>
                <Grid item xs={12} md={4}>
                  <TextField
                    label="City"
                    value={city}
                    onChange={(e) => setCity(e.target.value)}
                    fullWidth
                    margin="normal"
                  />
                </Grid>
                <Grid item xs={12} md={4}>
                  <TextField
                    label="State"
                    value={state}
                    onChange={(e) => setState(e.target.value)}
                    fullWidth
                    margin="normal"
                  />
                </Grid>
                <Grid item xs={12} md={4}>
                  <TextField
                    label="Zip"
                    value={zip}
                    onChange={(e) => setZip(e.target.value)}
                    fullWidth
                    margin="normal"
                  />
                </Grid>
                <Grid item xs={12} md={4}>
                  <TextField
                    label="County"
                    value={county}
                    onChange={(e) => setCounty(e.target.value)}
                    fullWidth
                    margin="normal"
                  />
                </Grid>
                <Grid item xs={12} md={4}>
                  <TextField
                    label="District"
                    value={district}
                    onChange={(e) => setDistrict(e.target.value)}
                    fullWidth
                    margin="normal"
                  />
                </Grid>
                <Grid item xs={12} md={4}>
                  <TextField
                    label="Main Contact"
                    value={main_contact}
                    onChange={(e) => setMainContact(e.target.value)}
                    fullWidth
                    margin="normal"
                  />
                </Grid>
                <Grid item xs={12} md={4}>
                  <TextField
                    label="Main Phone"
                    value={main_phone}
                    onChange={(e) => setMainPhone(e.target.value)}
                    fullWidth
                    margin="normal"
                  />
                </Grid>
                <Grid item xs={12} md={4}>
                  <TextField
                    label="Main Email"
                    value={main_email}
                    onChange={(e) => setMainEmail(e.target.value)}
                    fullWidth
                    margin="normal"
                  />
                </Grid>
                <Grid item xs={12} md={4}>
                  <TextField
                    label="Second Contact"
                    value={second_contact}
                    onChange={(e) => setSecondContact(e.target.value)}
                    fullWidth
                    margin="normal"
                  />
                </Grid>
                <Grid item xs={12} md={4}>
                  <TextField
                    label="Second Email"
                    value={second_email}
                    onChange={(e) => setSecondEmail(e.target.value)}
                    fullWidth
                    margin="normal"
                  />
                </Grid>
                <Grid item xs={12} md={4}>
                  <FormControl fullWidth margin="normal">
                    <InputLabel>Pathway</InputLabel>
                    <Select
                      value={pathway}
                      onChange={(e) => setPathway(e.target.value)}
                      label="Pathway"
                    >
                      {pathwayOptions.map((option, index) => (
                        <MenuItem key={index} value={option}>
                          {option}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12} md={4}>
                  <FormControl fullWidth margin="normal">
                    <InputLabel>Operations</InputLabel>
                    <Select
                      value={operations}
                      onChange={(e) => setOperations(e.target.value)}
                      label="Operations"
                    >
                      {operationsOptions.map((option, index) => (
                        <MenuItem key={index} value={option}>
                          {option}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12} container justifyContent="center">
                  <Button
                    type="submit"
                    variant="contained"
                    color="success"
                    endIcon={<AddCircle />}
                    sx={{ color: "white" }}
                  >
                    Add School
                  </Button>
                </Grid>
              </Grid>
            </form>
          )}
        </DialogContent>
      </Dialog>
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
        message="School has been added"
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      />
    </>
  );
};

export default AddForm;
